import { render, staticRenderFns } from "./AdminResponsible.vue?vue&type=template&id=a1c97630&scoped=true"
import script from "./AdminResponsible.vue?vue&type=script&lang=js"
export * from "./AdminResponsible.vue?vue&type=script&lang=js"
import style0 from "./AdminResponsible.vue?vue&type=style&index=0&id=a1c97630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c97630",
  null
  
)

export default component.exports